import * as React from 'react';
import { Paragraph, Title } from '@/components/atoms';
import { Typography } from 'antd';

type ArticleProps = {
  title: string;
  children?: React.ReactNode;
};

const Article = ({ title, children }: ArticleProps) => {
  return (
    <Typography>
      <Title level={4}>{title}</Title>
      <Paragraph>{children}</Paragraph>
    </Typography>
  );
};

Article.defaultProps = {
  children: undefined,
};

export default Article;
